/**
 * Error - Generic error page for handling unexpected errors and navigation.
 *
 * Displays a user-friendly error message and provides a button to return to the dashboard.
 * Used as a fallback for failed data loads or navigation errors.
 */
import { assets } from "@/assets/assets";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Error = () => {

    const navigate = useNavigate();
    return (
        <div className="h-screen flex flex-col items-center justify-center space-y-4">
            <h2 className="text-5xl font-medium text-center font-serif italic">Oops! Something went wrong.</h2>
            <p className="text-md text-muted-foreground text-center">We're sorry, but an error occurred while processing your request.</p>
            <Button variant="outline" className="mt-4 hover:cursor-pointer" onClick={() => navigate("/")}>
                Go to Dashboard
            </Button>
            <img src={assets.oh_no_img} alt="Oh No" className="hidden md:block md:w-[500px] w-[200px] fixed -bottom-40 -right-40 -z-10 -rotate-25" />
            <img src={assets.oh_no_img} alt="Oh No" className="block md:hidden w-[300px] fixed -bottom-25 -right-25 -z-10 -rotate-25" />
        </div>
    )
}

export default Error;
